import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Diagnostics from "@/containers/DiagnosticPage";

import {
  generateQueryArguments,
  generateUrlArguments,
  renderMetaData,
} from "@/utils";
import { PARTNER_URL_ARGUMENTS } from "@/constants";

import { wrapper } from "@/redux/Store";
import { getDiagnosticPageData } from "@/redux/DiagnosticReducer";
import { useAppDispatch } from "@/hooks";

const DiagnosticsPage = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const ref_code = router.query["ref_code"] as string;

  const tempQueryObject = { ...router.query };
  delete tempQueryObject.slug;
  const metaTags = renderMetaData({
    title: "Diagnostics",
    description: "Get Your Lab Tests with Our Partners at Discounted rates",
    h1Text: "Get Your Lab Tests with Our Partners at Discounted rates",
  });
  const queryArguments = generateQueryArguments(tempQueryObject);
  let urls_arguments = generateUrlArguments(queryArguments);

  urls_arguments = urls_arguments
    ? `${urls_arguments}&${PARTNER_URL_ARGUMENTS}`
    : `${urls_arguments}?${PARTNER_URL_ARGUMENTS}`;

  useEffect(() => {
    dispatch(getDiagnosticPageData({ slug: "diagnostics" }));
  }, []);

  return (
    <>
      {metaTags}
      <main>
        <Diagnostics
          urlParams={urls_arguments}
          slug="diagnostics"
          ref_code={ref_code}
        />
      </main>
    </>
  );
};

export default DiagnosticsPage;

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ query }) => {
      const ref_code = query["ref_code"];
      const res = await store.dispatch(
        getDiagnosticPageData({ slug: "diagnostics", ref_code })
      );
      if (!res?.payload) {
        return {
          notFound: true,
        };
      }
    }
);
